export enum InstantPayoutsModalScreens {
  EnterAmountScreen = 'EnterAmountScreen',
  VerifyAmountScreen = 'VerifyAmountScreen',
  FeedbackScreen = 'FeedbackScreen',
}
